import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';

import Box from '../Styled/Box';
import Typography from '../Typography/Typography';
import Checkbox from './Checkbox';

const TermsOfUse = ({
  value,
  onChange,
  checkboxProps,
  boxProps,
}) => {
  const { formatMessage: f } = useIntl();

  const terms = 'https://humanizadas-files.s3-sa-east-1.amazonaws.com/termos/termos_de_uso.pdf';
  const policies = 'https://humanizadas-files.s3-sa-east-1.amazonaws.com/termos/politica_de_privacidade.pdf';

  return (
    <Box display='flex' {...boxProps}>
      <Checkbox
        checked={value}
        value={value}
        onChange={onChange}
        boxProps={{ mr: 2 }}
        {...checkboxProps}
      />
      <span>
        <Typography display='inline' variant='body'>
          {f({ id: 'components.terms_of_use.read' })}
        </Typography>
        {' '}

        <Typography display='inline' link variant='body'>
          <a target='_black' href={terms}>{f({ id: 'components.terms_of_use.terms_link' })}</a>
        </Typography>
        {' '}

        <Typography display='inline' variant='body'>
          {f({ id: 'components.terms_of_use.and' })}
        </Typography>
        {' '}

        <Typography display='inline' link variant='body'>
          <a target='_black' href={policies}>{f({ id: 'components.terms_of_use.policies_link' })}</a>
        </Typography>
        {' '}

        <Typography display='inline' variant='body'>
          {f({ id: 'components.terms_of_use.platform' })}
        </Typography>
      </span>
    </Box>
  );
};

TermsOfUse.propTypes = {
  value: PropTypes.any.isRequired,
  onChange: PropTypes.func.isRequired,
  checkboxProps: PropTypes.object,
  boxProps: PropTypes.object,
};

TermsOfUse.defaultProps = {
  checkboxProps: {},
  boxProps: {},
};
export default TermsOfUse;
